import React, { useCallback } from 'react';
import get from 'lodash/get';
import { SuiContainer, SuiSpinner } from '@splashthat/sui';
import { Headline } from 'common/components/Typography';
import Spacer from 'common/components/Spacer';
import { useEditor } from '@splashthat/splash-cms-engine';
import CustomCssTools from 'common/components/TouchpointEditor/tools/CustomCssTools';

import {
    TitleContainer,
    EditElementMenuStyles,
    StyledBackArrowNav,
    LoadingSpinnerContainer,
} from './EditElementTools.styles';

export default function EditElementMenu() {
    const { actions, ...node } = useEditor((state) => state.nodes[state.events.selected]);

    const RelatedSettings = get(node, 'related.settings');
    const CssClasses = useCallback(() => <CustomCssTools spacer={'both'} />, [node?.id]);

    return (
        <EditElementMenuStyles variation="full-height full-width flex-no-shrink" isOpened={!!RelatedSettings}>
            <TitleContainer variation="flex-horizontal-left full-width">
                <StyledBackArrowNav onClick={() => actions.unselectAllNodes()} />
                <Headline tag="h2" size="small">
                    {get(node, 'displayName') || get(node, 'meta.displayName')}
                </Headline>
            </TitleContainer>
            <SuiContainer>
                <Spacer />
                <React.Suspense
                    fallback={
                        <LoadingSpinnerContainer>
                            <SuiSpinner loading size="medium" aria-label="loading" />
                        </LoadingSpinnerContainer>
                    }
                >
                    {!!RelatedSettings && <RelatedSettings />}
                    {!!RelatedSettings && <CssClasses />}
                </React.Suspense>
            </SuiContainer>
        </EditElementMenuStyles>
    );
}
